import React from 'react'

export const DynamicDataContext = React.createContext()
